import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Crossicon from "../../Icon/Crossicon";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  outline: "none",
  overflow: "auto",
  '&::-webkit-scrollbar': { width: '8px' },
  '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '10px' },
  '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '10px' },
  '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
};

const VideoModal = ({ open, handleClose, videoSrc }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
        >
          <Crossicon width={"20"} height={"20"} />
        </IconButton>
        <video
          width="100%"
          height="auto"
          controls
          autoPlay
          style={{ borderRadius: "8px" }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box>
    </Modal>
  );
};

export default VideoModal;

